import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { InlineCard } from './';
import { isSafeUrl } from '@atlaskit/adf-schema';
import { LazyLoadedDatasourceRenderFailedAnalyticsWrapper } from '@atlaskit/link-datasource';
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
export var CardErrorBoundary = /*#__PURE__*/function (_React$PureComponent) {
  function CardErrorBoundary() {
    var _this;
    _classCallCheck(this, CardErrorBoundary);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CardErrorBoundary, [].concat(args));
    _defineProperty(_this, "state", {
      isError: false,
      error: null
    });
    _defineProperty(_this, "onClickFallback", function (e) {
      var _this$props = _this.props,
        onClick = _this$props.onClick,
        url = _this$props.url;
      e.preventDefault();
      if (onClick) {
        onClick(e, url);
      }
    });
    return _this;
  }
  _inherits(CardErrorBoundary, _React$PureComponent);
  return _createClass(CardErrorBoundary, [{
    key: "render",
    value: function render() {
      if (this.state.isError) {
        var _this$props2 = this.props,
          url = _this$props2.url,
          isDatasource = _this$props2.isDatasource,
          UnsupportedComponent = _this$props2.unsupportedComponent,
          datasourceId = _this$props2.datasourceId;
        if (url) {
          var fallback = /*#__PURE__*/React.createElement("a", {
            href: url,
            onClick: this.onClickFallback
          }, url);
          if (isDatasource) {
            if (isSafeUrl(url)) {
              return /*#__PURE__*/React.createElement(LazyLoadedDatasourceRenderFailedAnalyticsWrapper, {
                datasourceId: datasourceId,
                error: this.state.error
              }, /*#__PURE__*/React.createElement(InlineCard
              // Ignored via go/ees005
              // eslint-disable-next-line react/jsx-props-no-spreading
              , this.props));
            } else {
              return /*#__PURE__*/React.createElement(LazyLoadedDatasourceRenderFailedAnalyticsWrapper, {
                datasourceId: datasourceId,
                error: this.state.error
              }, fallback);
            }
          } else {
            return fallback;
          }
        } else {
          return /*#__PURE__*/React.createElement(UnsupportedComponent, null);
        }
      }
      return this.props.children;
    }
  }, {
    key: "componentDidCatch",
    value: function componentDidCatch(_error) {
      this.setState({
        isError: true,
        error: _error
      });
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      return {
        isError: true,
        error: error
      };
    }
  }]);
}(React.PureComponent);